<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
      <div class="col-6 h5 text-muted p-0">SMS Campaign</div>
      <div class="col-6 p-0">
        <span class="float-end">
          <button type="button" class="btn btn-outline-secondary btn-sm" title="Create SMS Campaign" (click)="createSMSCampaign()">
            Create SMS Campaign
          </button>
        </span>
      </div>
    </div>
  
    <div class="row bg-light p-2">
      <div class="col-12">

        <!-- Filters -->
        <div class="row pt-2 pb-2 mb-2 bg-white">
            <div class="col-12">
                <div class="row mt-2 mb-2">
                    <div class="col-4">
                        <select class="form-select text-muted" [(ngModel)]="selectedStore" (change)="onStoreChange($event)" [disabled]="smsCampaignsLoading === true" *ngIf="stores.length > 0">
                            <option *ngFor="let store of stores" [value]="store.store_id">{{ store.store_name }}</option>
                        </select>
                    </div>
                    <div class="col-8">
                        <div class="spinner-grow spinner-grow-sm text-info" role="status" *ngIf="storesLoading === true"></div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row pt-2 pb-2 bg-white">
            <div class="col-12">

                <!-- SMS Campaigns -->
                <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="smsCampaignsLoading === true">
                    <div class="col-12">
                    <div class="spinner-border text-info  mt-4" role="status"></div>
                    </div>
                </div>

                <div class="row mt-2 pt-2 pb-4">
                    <div class="col-12">
                    <div class="row text-center mt-4 mb-4" *ngIf="storesLoading == false && smsCampaignsLoading == false && smsCampaigns.length == 0">
                        <i-bs class="text-black-50 mt-4 pt-4" name="phone" width="30" height="30"></i-bs>
                        <div class="col-12 mb-4 pb-4 text-black-50">SMS campaigns not found</div>
                    </div>

                    <div class="row" *ngIf="smsCampaignsCount > 0">
                        <div class="col-12">
                            <!-- Pagination Top -->
                            <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onSmsCampaignsPageChange($event)"></pagination-controls>
                        </div>
                    </div>

                    <div class="row sms-campaign-list-outer" *ngIf="smsCampaignsLoading === false && smsCampaigns.length > 0">
                        <div class="col-12">
                            <!-- Header -->
                            <div class="row header-row border-bottom m-1">
                                <div class="col-3 title text-muted">Campaign Name</div>
                                <div class="col-3 title text-muted">Store</div>
                                <div class="col-1 title text-muted">Target Type</div>
                                <div class="col-1 title text-muted">Targeted Users</div>
                                <div class="col-1 title text-muted">Created Date</div>
                                <div class="col-1 title text-muted">Schedule Date</div>
                                <div class="col-1 title text-muted">Campaign Status</div>
                                <div class="col-1 title text-muted">Delivered</div>
                            </div>

                            <!-- Data -->
                            <div class="row data-row border-bottom border-light m-1" *ngFor="let smsCampaign of smsCampaigns | paginate: { itemsPerPage: 10, currentPage: smsCampaignsPage, totalItems: smsCampaignsCount }; let i = index;">
                                <div class="col-3 value text-muted cursor-pointer" [ngbPopover]="smsCampaignDetailsPop" triggers="manual" #p1="ngbPopover" (mouseleave)="p1.close()" (click)="toggleSmsCampaignDetailsPopover(p1, smsCampaign)">
                                    <u>{{ smsCampaign.campaign_name }}</u>
                                    <span *ngIf="smsCampaign?.campaign_status == 0">
                                        &nbsp;&nbsp;<i-bs class="text-secondary cursor-pointer" name="pencilSquare" title="Edit SMS Campaign" (click)="onEditSmsCampaign(smsCampaign)"></i-bs>
                                    </span>
                                </div>
                                <div class="col-3 value text-muted">
                                    {{ smsCampaign.store_name }}
                                </div>
                                <div class="col-1 value text-muted">
                                    <span *ngIf="smsCampaign?.target_type == 'new'">New</span>
                                    <span *ngIf="smsCampaign?.target_type == 'existing'">Existing</span>
                                </div>
                                <div class="col-1 value text-muted">
                                    {{ smsCampaign.no_of_users }}
                                </div>
                                <div class="col-1 value text-muted">
                                    {{ smsCampaign.create_date | date : 'MMM d, y' : 'UTC' }}
                                </div>
                                <div class="col-1 value text-muted">
                                    {{ smsCampaign.schedule_date | date : 'MMM d, y' : 'UTC' }}
                                </div>
                                <div class="col-1 value"> 
                                    <span class="text-warning" *ngIf="smsCampaign?.campaign_status == 0">Scheduled</span>
                                    <span class="text-success" *ngIf="smsCampaign?.campaign_status == 1">Completed</span>
                                    <span class="text-danger" *ngIf="smsCampaign?.campaign_status == 2">Cancelled</span>
                                </div>
                                <div class="col-1 value"> 
                                    {{ smsCampaign?.success_count }}/{{ smsCampaign.no_of_users }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination Bottom -->
                    <div class="row mt-2">
                        <div class="col-12">
                        <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                            nextLabel="" (pageChange)="onSmsCampaignsPageChange($event)" *ngIf="smsCampaignsCount > 0"></pagination-controls>
                        </div>
                    </div>
                    </div>
                </div>
        
            </div>
        </div>
        
      </div>
    </div>
  </div>

  <!-- SMS Campaign Details Popover-->
  <ng-template #smsCampaignDetailsPop>
    <div class="container popover-outer p-0">
        <div class="row">
            <div class="col-12">
                <div class="text-muted fw-bold">SMS Text</div>
                <div class="sms-text text-muted fw-normal">{{ smsCampaignDetailsPopData.message }}</div>
            </div>
        </div>
    </div>
  </ng-template>